import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // Add item to cart (increase quantity if already exists)
  const addToCart = (newItem) => {
    setCart((prevCart) => {
      const existingIndex = prevCart.findIndex(
        (item) =>
          item.fileName === newItem.fileName &&
          item.colorType === newItem.colorType &&
          item.paperSize === newItem.paperSize &&
          item.paperType === newItem.paperType
      );

      if (existingIndex !== -1) {
        // If item exists, increase quantity and copies
        const updatedCart = [...prevCart];
        updatedCart[existingIndex].quantity += newItem.quantity || 1;
        updatedCart[existingIndex].copies += newItem.copies || 1;
        return updatedCart;
      } else {
        // Otherwise, add as a new item
        return [
          ...prevCart,
          { ...newItem, quantity: newItem.quantity || 1, copies: newItem.copies || 1 },
        ];
      }
    });
  };

  // Remove item from cart
  const removeFromCart = (index) => {
    setCart((prevCart) => prevCart.filter((_, i) => i !== index));
  };

  // Update any cart item (e.g., quantity, paper type, copies)
  const updateCartItem = (index, updatedItem) => {
    setCart((prevCart) => {
      const updatedCart = [...prevCart];
      updatedCart[index] = updatedItem;
      return updatedCart;
    });
  };

  // Clear entire cart (e.g., after checkout)
  const clearCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateCartItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
